import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Constants } from 'src/app/helpers/messages';
import { AddUserComponent } from '../user-mgt/add-user/add-user.component';
import { AddCatalogueComponent } from './add-catalogue/add-catalogue.component';

@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.scss']
})
export class CatalogueComponent implements OnInit {
  
  
  settingsList = [
    {name:"Designations", description:"Define the various designations here", 
      icon:'person'
    },
    {name:"Department", description:'Define the various departments here', icon:'vpn_key'},
    {name:"Locations", description:'Define business locations (branches)', icon:'payment', },
    // {name:"", description:'Invite members to your group', icon:'people', route:'invitation'},
    // {name:"Notification Settings", description:'Customise your notifications', icon:'notifications', route:'/notification-settings'},
  ]

  @ViewChild(MatPaginator, {static:false}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  displayedColumns: string[] = [ 'code','created', 'name', 'action'];

  userList = [
    {name:'Designation 1', datecreated:'23 March, 2020', code:'DN34002'},
    {name:'Designation 1', datecreated:'23 March, 2020', code:'DN34002'},
    {name:'Designation 1', datecreated:'23 March, 2020', code:'DN34002'},
    {name:'Designation 1', datecreated:'23 March, 2020', code:'DN34002'},
    {name:'Designation 1', datecreated:'23 March, 2020', code:'DN34002'},
    {name:'Designation 1', datecreated:'23 March, 2020', code:'DN34002'},
    {name:'Designation 1', datecreated:'23 March, 2020', code:'DN34002'},
  ]

  listData: MatTableDataSource<unknown>;

  constructor(private dialog:MatDialog) { }

  ngOnInit(): void {
    this.listData = new MatTableDataSource(this.userList)
    this.listData.paginator = this.paginator;   
  }

  addUser() {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = false;
    dialogConfig.width = '25%'
    dialogConfig.minHeight = '30vh'
    dialogConfig.disableClose = true
    // dialogConfig.data = this.features
    
    this.dialog.open(AddCatalogueComponent, dialogConfig)
    .afterClosed().subscribe( res => {
      if(res == Constants.COMPLETED){
        
      }
    })
  }
}
